import React from 'react';
import moment from 'moment';
import { IconTrophy } from '@tabler/icons';
import { Notification as NotificationType } from 'types/notification';
import cn from 'classnames';

import styles from '../styles.module.scss';

type Props = {
    item: NotificationType;
    onHandleVisible: (visible: boolean, id: number) => void;
    goToAuthorOrder: (id: number) => void;
};

export const OrderStatus = ({ item, onHandleVisible, goToAuthorOrder }: Props) => {
    const visibleIco = <div className={ styles.newBagle } />;
    const created = moment(item.createdAt).fromNow();

    const txt = item.types === 'customerOrderDone' ? (
        `<b>${item.executors?.firstName} ${item.executors?.lastName}</b> подтвердил готовность вашего заказа`
    ) : (
        `<b>${item.executors?.firstName} ${item.executors?.lastName}</b> перевел ваш заказ в статус <b>#status#</b>`
    );

    return (
        <div
            className={ styles.ls }
            onMouseEnter={ () => onHandleVisible(item.visible, item.id) }
            onClick={ () => goToAuthorOrder(item.orderId) }
        >
            <div className={ cn(styles.ls_img, styles.executorUpdateStatus) }>
                <IconTrophy />
                { !item.visible && (visibleIco) }
            </div>
            <div className={ styles.ls_body }>
                <div className={ styles.ls_txt } dangerouslySetInnerHTML={ { __html: txt } } />
                <div className={ styles.ls_time }>{ created }</div>
            </div>
        </div>
    );
};
